import Vue from 'vue';
import Vuetify from 'vuetify'
import App from './App.vue'
import router from './router'
import VueAxios from 'vue-axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSignInAlt, faSignOutAlt, faUser, faBolt, faFire, faCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { securedAxiosInstance, plainAxiosInstance } from './backend/axios'
import VueCurrencyFilter from 'vue-currency-filter'
const moment = require('moment')
require('moment/locale/nl')
moment.defaultFormat = 'dd DD-MM-YYYY HH:mm'

import 'vuetify/dist/vuetify.min.css'
import '@fortawesome/fontawesome-free/css/all.css'

library.add(faSignInAlt, faSignOutAlt, faUser, faBolt, faFire, faCircle)

Vue.config.productionTip = false

Vue.use(require('vue-moment'), {
  moment,
})

Vue.prototype.$localStorage = new Vue({
  data: { 
     // token property returning the ls token value 
     access: window.localStorage.getItem('access'),
     email: window.localStorage.getItem('email'),
     signedIn: window.localStorage.getItem('signedIn'),
  },
  watch:{ 
     // watcher listening for changes on the token property
     // to ensure the new value is written back to ls 
     access(value){ window.localStorage.setItem('access', value) },
     email(value){ window.localStorage.setItem('email', value) },
     signedIn(value){ window.localStorage.setItem('signedIn', value) },
  }
})

Vue.use(VueCurrencyFilter,
{
  symbol : '€',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
})

Vue.use(Vuetify, {
  iconfont: 'fa',
})

Vue.use(VueAxios, {
  secured: securedAxiosInstance,
  plain: plainAxiosInstance
})
Vue.component('font-awesome-icon', FontAwesomeIcon)

/* eslint-disable no-new */
new Vue({
  router,
  securedAxiosInstance,
  plainAxiosInstance,
  render: h => h(App)
}).$mount('#app')

